var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "pt-0",
          attrs: {
            cols: "12"
          }
        },
        [_c("gg-card-title", [_vm._v(" Notifications ")])],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _vm._v(" Notifications "),
                  _vm.notificationsCount > 0
                    ? _c("dismiss-all", {
                        staticClass: "float-right",
                        attrs: {
                          location: "history"
                        },
                        on: {
                          update: _vm.update
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.notifications,
                      loading: _vm.loading
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.title",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [
                            item.hasLink
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#"
                                    },
                                    on: {
                                      click: function click($event) {
                                        $event.preventDefault()
                                        return _vm.visitNotification(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(item.title) + " ")]
                                )
                              : _c("span", [_vm._v(_vm._s(item.title))])
                          ]
                        }
                      },
                      {
                        key: "item.description",
                        fn: function fn(_ref2) {
                          var item = _ref2.item
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "d-block table-description-text"
                              },
                              [_vm._v(" " + _vm._s(item.description) + " ")]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.status",
                        fn: function fn(_ref3) {
                          var item = _ref3.item
                          return [
                            _vm.isItemNew(item)
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "pr-1",
                                    attrs: {
                                      color: "red"
                                    }
                                  },
                                  [_vm._v(" mdi-circle ")]
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function fn(_ref4) {
                          var item = _ref4.item
                          return [
                            _vm.isItemNew(item)
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.dismissNotification(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v(" Dismiss ")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }